<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp mesaj="" v-model="loginstatus"></loadingcomp>

    <v-layout row justify-center>
      <v-dialog v-model="classdialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar color="info" size="120px" dark>
              <v-toolbar-title class="baslikfont">{{classdialog_baslik}}</v-toolbar-title>

            </v-toolbar>
          </v-flex>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout row="" wrap>
                <div class="flex md12">
                  <v-text-field :label="this.$t('Class-Name')" mask="N" :color="color" v-model="classadi"
                    :error-messages="errors.collect('classadi1')" v-validate="'required'" data-vv-name="classadi1"
                    required>
                  </v-text-field>
                </div>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="classdialog=false">{{$t('Cancel')}}</v-btn>
            <v-btn id="bkaydet" color="blue darken-1" flat @click.native="ClassKaydet()">{{$t("save_button")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="parkurdialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar color="info" size="120px" dark>
              <v-toolbar-title class="baslikfont">{{parkurdialog_baslik}}</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout row="" wrap>
                <div class="flex md12">
                  <v-text-field v-if="parkaybtn" :label="this.$t('Track-Code')" mask="NNN" :color="color"
                    v-model="Parkur.ParkurKod" :error-messages="errors.collect('parkurkod')" v-validate="'required'"
                    data-vv-name="parkurkod" required>
                  </v-text-field>
                  <v-text-field :label="$t('Description')" :color="color" v-model="Parkur.Aciklama">
                  </v-text-field>
                </div>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="parkurdialog=false">{{$t('Cancel')}}</v-btn>



            <v-tooltip bottom>
              <v-btn v-if="pargncbtn" color="info" :disabled="!sayfayetki.Update" slot="activator"
                @click="ParkurKaydet()" flat>
                {{ $t('Update') }}
              </v-btn>
              <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
              <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
            </v-tooltip>

            <v-btn v-if="parkaybtn" color="blue darken-1" flat @click="ParkurKaydet()">{{$t("save_button")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


      <v-dialog v-model="havayoludialog" persistent min-width="650px" max-width="500px">
        <v-card color="grey lighten-5">

          <v-flex xs12 sm12>
            <v-toolbar color="info" size="120px" dark>
              <v-toolbar-title class="baslikfont">{{havayoludialog_baslik}}</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-card-text>

            <v-tabs style="width:100%;" dark="" v-model="active" color="blue darken-3" slot="extension" slider->
              <v-tabs-slider></v-tabs-slider>
              <v-tab href='#0'>
                {{$t("tab_general")}}
              </v-tab>
              <v-tab-item :id="'0'" style="width:100%; height:650px;">
                <v-layout row="" wrap="">
                  <v-flex xs12 sm12 md12>


                    <v-form ref="formtarih" v-model="valid" lazy-validation>

                      <v-layout row="" wrap>
                        <div class="flex md12">

                          <v-layout>
                            <v-text-field hide-details="" :disabled="islemhy=='guncelle'" :label="$t('Airline-Code')"
                              mask="NNN" :color="color" v-model="havayolu.HavaYoluKodu"
                              :rules="[v => !!v || $t('Mandatory-Areas')]">
                            </v-text-field>
                            <v-text-field :label="$t('Form-No')" :disabled="islemhy=='guncelle'" hide-details="" mask="###"
                              :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="havayolu.FormNo" :color="color">
                            </v-text-field>
                          </v-layout>
                          <v-text-field :label="$t('Airline-Desc')" :rules="[v => !!v || $t('Mandatory-Areas')]" hide-details=""
                            :color="color" v-model="havayolu.HavaYoluAdi">
                          </v-text-field>
                          <v-layout>

                            <yuzdeinput :etiket="$t('Domestic-Line') + ' %'" :tabdeger="0" v-model="havayolu.IchatYuzde1"
                              :autocomplete="'autocomplete'"></yuzdeinput>
                            <yuzdeinput :etiket="$t('International-Line') + ' %'" :tabdeger="0" v-model="havayolu.DishatYuzde1"
                              :autocomplete="'autocomplete'"></yuzdeinput>
                          </v-layout>

                        
                         <cariaracomp v-bind:etiket="$t('Current-Account')" v-bind:value="havayolu.Cari.Kod" :loading="loading" 
                                  v-model="havayolu.Cari.Kod" v-bind:statecariyedek="statecari"></cariaracomp>

                          <v-select hide-details="" v-model="havayolu.Doviz.DovizKod" :items="doviztipi" clearable
                            item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')"></v-select>
                          <v-layout>
                            <v-text-field hide-details="" :label="$t('GSAGross-Net')" :color="color"></v-text-field>

                            <v-text-field hide-details="" :label="$t('Airline-Control')" :color="color"
                              v-model="havayolu.HavayoluKontrolu"></v-text-field>
                          </v-layout>
                          <v-layout>
                            <v-autocomplete hide-details="" :items="bankapositems" v-model="havayolu.HavaYoluPosKodu"
                              item-text="Title" item-value="PosKodu" clearable :label="$t('Pos-Code')"></v-autocomplete>
                            <v-autocomplete :items="bankapositems" hide-details="" item-text="Title"
                              item-value="PosKodu" clearable v-model="havayolu.MuhasebeKodlari.HavayoluPosMuhasebeKodu"
                              :label="$t('Accounting-Pos-Code')">
                            </v-autocomplete>
                          </v-layout>

                          <v-radio-group hide-details="" v-model="havayolu.ServisHesapTip"
                            :label="$t('Service-Calculation-Type')">
                            <v-radio :label="$t('Ticket-Single')" :value="0"></v-radio>
                            <v-radio :label="$t('Return-v3')" :value="1"></v-radio>

                          </v-radio-group>


                          <v-checkbox hide-details="" label="GSA" value="1" v-model="havayolu.GSA"></v-checkbox>
                          <v-checkbox hide-details="" :label="$t('Has-Current-Account')" value="1" v-model="havayolu.Carimi">
                          </v-checkbox>

                          <v-checkbox hide-details="" :label="$t('Service-Amount-Belongs-Airlines')" value="1"
                            v-model="havayolu.ServisUcreti"></v-checkbox>
                          <v-checkbox hide-details="" :label="$t('YFF-Received-from-Parameter-Reset')" :value="1"
                            v-model="havayolu.YffSifir"></v-checkbox>



                        </div>
                      </v-layout>
                    </v-form>


                  </v-flex>


                </v-layout>

              </v-tab-item>

              <v-tab href='#1' ripple v-if="PB=='TRY'">
                {{ $t('Accounting-Codes') }}
              </v-tab>

              <v-tab-item :id="'1'" style="width:100%; ">
                <v-layout row="" wrap="">
                  <v-flex xs12 sm12 md12>
                    <v-card flat class="white--text">
                      <v-card flat color="grey lighten-4">
                        <v-card-actions>
                          <v-layout row="" wrap>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" :label="this.$t('Domestic-Line-Accounting-Code')" :color="color"
                                v-model="havayolu.MuhasebeKodlari.IchatMuhKodu"></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" :label="this.$t('International-Line-Accounting-Code')" :color="color"
                                v-model="havayolu.MuhasebeKodlari.DishatMuhKodu"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-text-field hide-details="" label="BSP Hat Muhasebe Kodu" :color="color"
                                v-model="havayolu.MuhasebeKodlari.BsphatMuhKodu"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-text-field hide-details="" :label="this.$t('Airline-POS-Accounting-Code')" :color="color"
                                v-model="havayolu.MuhasebeKodlari.HavayoluPosMuhasebeKodu"></v-text-field>
                            </v-flex>



                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" v-model="havayolu.MuhasebeKodlari.Reserve1"
                                :label="$t('Reserve-Codes',{value:'1'})"> </v-text-field>
                            </v-flex>

                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" v-model="havayolu.MuhasebeKodlari.Reserve2"
                                :label="$t('Reserve-Codes',{value:'2'})"> </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" v-model="havayolu.MuhasebeKodlari.Reserve3"
                                :label="$t('Reserve-Codes',{value:'3'})"> </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" v-model="havayolu.MuhasebeKodlari.Reserve4"
                                :label="$t('Reserve-Codes',{value:'4'})"> </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" v-model="havayolu.MuhasebeKodlari.Reserve5"
                                :label="$t('Reserve-Codes',{value:'5'})"> </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" v-model="havayolu.MuhasebeKodlari.Reserve6"
                                :label="$t('Reserve-Codes',{value:'6'})"> </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" v-model="havayolu.MuhasebeKodlari.Reserve7"
                                :label="$t('Reserve-Codes',{value:'7'})"> </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" v-model="havayolu.MuhasebeKodlari.Reserve8"
                                :label="$t('Reserve-Codes',{value:'8'})"> </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" v-model="havayolu.MuhasebeKodlari.Reserve9"
                                :label="$t('Reserve-Codes',{value:'9'})"> </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" v-model="havayolu.MuhasebeKodlari.Reserve10"
                                :label="$t('Reserve-Codes',{value:'10'})"> </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" v-model="havayolu.MuhasebeKodlari.Reserve11"
                                :label="$t('Reserve-Codes',{value:'11'})"> </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" v-model="havayolu.MuhasebeKodlari.Reserve12"
                                :label="$t('Reserve-Codes',{value:'12'})"> </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" v-model="havayolu.MuhasebeKodlari.Reserve13"
                                :label="$t('Reserve-Codes',{value:'13'})"> </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" v-model="havayolu.MuhasebeKodlari.Reserve14"
                                :label="$t('Reserve-Codes',{value:'14'})"> </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" v-model="havayolu.MuhasebeKodlari.Reserve15"
                                :label="$t('Reserve-Codes',{value:'15'})"> </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" v-model="havayolu.MuhasebeKodlari.Reserve16"
                                :label="$t('Reserve-Codes',{value:'16'})"> </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" v-model="havayolu.MuhasebeKodlari.Reserve17"
                                :label="$t('Reserve-Codes',{value:'17'})"> </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" v-model="havayolu.MuhasebeKodlari.Reserve18"
                                :label="$t('Reserve-Codes',{value:'18'})"> </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" v-model="havayolu.MuhasebeKodlari.Reserve19"
                                :label="$t('Reserve-Codes',{value:'19'})"> </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" v-model="havayolu.MuhasebeKodlari.Reserve20"
                                :label="$t('Reserve-Codes',{value:'20'})"> </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" v-model="havayolu.MuhasebeKodlari.Reserve21"
                                :label="$t('Reserve-Codes',{value:'21'})"> </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" v-model="havayolu.MuhasebeKodlari.Reserve22"
                                :label="$t('Reserve-Codes',{value:'22'})"> </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" v-model="havayolu.MuhasebeKodlari.Reserve23"
                                :label="$t('Reserve-Codes',{value:'23'})"> </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" v-model="havayolu.MuhasebeKodlari.Reserve24"
                                :label="$t('Reserve-Codes',{value:'24'})"> </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" v-model="havayolu.MuhasebeKodlari.Reserve25"
                                :label="$t('Reserve-Codes',{value:'25'})"> </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" v-model="havayolu.MuhasebeKodlari.Reserve26"
                                :label="$t('Reserve-Codes',{value:'26'})"> </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" v-model="havayolu.MuhasebeKodlari.Reserve27"
                                :label="$t('Reserve-Codes',{value:'27'})"> </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" v-model="havayolu.MuhasebeKodlari.Reserve28"
                                :label="$t('Reserve-Codes',{value:'28'})"> </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" v-model="havayolu.MuhasebeKodlari.Reserve29"
                                :label="$t('Reserve-Codes',{value:'29'})"> </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field hide-details="" v-model="havayolu.MuhasebeKodlari.Reserve30"
                                :label="$t('Reserve-Codes',{value:'30'})"> </v-text-field>
                            </v-flex>





                          </v-layout>


                        </v-card-actions>
                      </v-card>
                    </v-card>

                  </v-flex>


                </v-layout>
              </v-tab-item>

            </v-tabs>



















          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="havayoludialog=false">{{$t('Cancel')}}</v-btn>

            <v-tooltip bottom>
              <v-btn v-if="pargncbtn" color="info" :disabled="!sayfayetki.Update" slot="activator"
                @click="HavaYoluKaydet()" flat>
                {{ $t('Update') }}
              </v-btn>
              <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
              <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
            </v-tooltip>

            <v-btn v-if="parkaybtn" color="blue darken-1" flat @click="HavaYoluKaydet()">{{$t("save_button")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


    </v-layout>
    <v-layout row wrap>
      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title class="baslikfont">{{$t('Airline-Tour-Class-Identification')}} </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-layout>

    <v-container fluid="">
      <v-layout row wrap>

        <v-flex pa-1 xs12 sm5 md5>
          <v-toolbar size="120px" dark color="info">
            <v-icon dark>flight</v-icon>
            <v-toolbar-title class="baslikfont">{{$t('Airline')}}</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="havayoluekle()" flat>
                <v-icon medium="" right dark>add_box</v-icon>
              </v-btn>
              <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
              <span v-if="sayfayetki.Save">{{  $t('Add-v2', { value: $t('Airline')}) }} </span>
            </v-tooltip>






          </v-toolbar>
          <v-card>
            <v-card-title>
              <v-spacer></v-spacer>

              <div class="flex md12">
                <v-text-field append-icon="search" :label="this.$t('Search')" single-line hide-details
                  v-model="search1" id="datatable">
                </v-text-field>
              </div>
            </v-card-title>
            <v-data-table :headers="headers1" :loading="progress" :rows-per-page-items=[10,100] :items="items"
              :search="search1">
              <v-progress-linear slot="progress" indeterminate></v-progress-linear>

              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.HavaYoluKodu }}</td>
                <td class="text-xs-left">{{ props.item.FormNo }}</td>
                <td class="text-xs-left">{{ props.item.HavaYoluAdi }}</td>
                <td class="justify-center layout px-0">
                  <v-icon @click="havayolugetir(props.item)">edit</v-icon>
                  <v-icon @click="havayolusilsor(props.item)">delete</v-icon>
                </td>
              </template>
              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                {{ $t('No-records-searched-for', { value: search1}) }}
              </v-alert>
            </v-data-table>
          </v-card>
        </v-flex>


        <v-flex pa-1 xs12 sm5 md5>
          <v-toolbar size="120px" dark color="info">


            <v-icon dark>flight_takeoff</v-icon>
            <v-toolbar-title class="baslikfont">{{$t('Route')}}</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="parkuraktar()" flat>
                <v-icon medium="" right dark>get_app</v-icon> {{$t('Transfer-Track')}}
              </v-btn>
              <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
              <span v-if="sayfayetki.Save">{{$t('Transfer-Track')}}</span>
            </v-tooltip>



            <v-tooltip bottom>
              <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="parkurekle()" flat>
                <v-icon medium="" right dark>add_box</v-icon>
              </v-btn>
              <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
              <span v-if="sayfayetki.Save">{{ $t('Add-v2',{ value: $t('Route') }) }}</span>
            </v-tooltip>



          </v-toolbar>
          <v-card>
            <v-card-title>

              <div class="flex md12">
                <v-text-field append-icon="search" :label="this.$t('Search')" single-line hide-details
                  v-model="search2" id="datatable">
                </v-text-field>
              </div>
            </v-card-title>
            <v-data-table :headers="headers2" :loading="progress" :rows-per-page-items=[10,100] :items="itemsparkur"
              :search="search2">
              <v-progress-linear slot="progress" indeterminate></v-progress-linear>

              <template slot="items" slot-scope="props">

                <td class="text-xs-left">{{ props.item.ParkurKod }}</td>
                <td class="text-xs-left">{{ props.item.Aciklama }}</td>
                <v-icon class="mr-2" @click="parkurgetir(props.item)"> edit </v-icon>
                <v-icon @click="parkursilsor(props.item.ParkurKod)"> delete</v-icon>

              </template>
              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                {{ $t('No-records-searched-for', { value: search2}) }}
              </v-alert>
            </v-data-table>
          </v-card>
        </v-flex>


        <v-flex pa-1 xs12 sm2 md2>

          <v-toolbar size="120px" dark color="info">
            <v-icon dark>view_list</v-icon>
            <v-toolbar-title class="baslikfont">{{$t('Class')}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="classekle()" flat>
                <v-icon medium="" right dark>add_box</v-icon>
              </v-btn>
              <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
              <span v-if="sayfayetki.Save">{{ $t('Add-v2',{ value: $t('Class') }) }}</span>
            </v-tooltip>



          </v-toolbar>
          <v-card>
            <v-card-title>
              <v-spacer></v-spacer>

              <div class="flex md12">
                <v-text-field append-icon="search" :label="$t('Search')" single-line hide-details v-model="search3"
                  id="datatable">
                </v-text-field>
              </div>
            </v-card-title>
            <v-data-table :headers="headers3" :loading="progress" :rows-per-page-items=[10,100] :items="classitems"
              :search="search3">
              <v-progress-linear slot="progress" indeterminate></v-progress-linear>

              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.ClassAdi }}</td>
                <v-icon @click="classsilsor(props.item.ClassAdi)"> delete</v-icon>
              </template>
              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                {{ $t('No-records-searched-for', { value: search3}) }}
              </v-alert>
            </v-data-table>
          </v-card>
        </v-flex>


      </v-layout>
    </v-container>

    <v-dialog v-model="dialogkisamesaj" width="500">

      <v-card>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title>{{ $t('Warning') }}!</v-toolbar-title>
          </v-toolbar>
        </v-flex>

        <v-card-text>
          {{this.kisamesaj}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialogkisamesaj=false">
            iptal
          </v-btn>



          <v-tooltip bottom>
            <v-btn v-if="hyoluok" :disabled="!sayfayetki.Delete" slot="activator" @click="HavaYoluSil()" flat>
              {{ $t('OK') }}
            </v-btn>
            <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
            <span v-if="sayfayetki.Delete">Havayolu Sil</span>
          </v-tooltip>


          <v-tooltip bottom>
            <v-btn v-if="clsok" :disabled="!sayfayetki.Delete" slot="activator" @click="ClassSil()" flat>
              {{ $t('OK') }}
            </v-btn>
            <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
            <span v-if="sayfayetki.Delete">Class Sil</span>
          </v-tooltip>


          <v-tooltip bottom>
            <v-btn v-if="parok" :disabled="!sayfayetki.Delete" slot="activator" @click="ParkurSil()" flat>
              {{ $t('OK') }}
            </v-btn>
            <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
            <span v-if="sayfayetki.Delete">Parkur Sil</span>
          </v-tooltip>



        </v-card-actions>
      </v-card>
    </v-dialog>


    <template>

      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
      </v-card>
      <v-dialog v-model="dialog1" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">{{ $t('Warning') }} !</v-card-title>
          <v-card-text>{{dialogmessage1}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat @click.native="dialog1=false">{{ $t('OK') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </template>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import faturalistesiVue from '../faturalar/faturalistesi.vue';
  import yuzdeinput from '../customcomp/yuzdeinput'
  import havayollaricompVue from './partpage/havayollaricomp.vue';
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import loadingcomp from "@/components/app/customcomp/loadingcomp"
  import cariaracomp from '@/components/app/customcomp/cariaracomp'

  export default {
    data() {
      return {
        PB:"TRY",
        silinecekFormNo:"",
        loginstatus:false,
        islemhy: 'guncelle',
        active: '0',
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        valid: true,
        havayolu: {
          HavaYoluTitle: null,
          HavaYoluKodu: null,
          FormNo: null,
          HavaYoluAdi: null,
          GSA: '0',
          IchatYuzde1: 0,
          IchatYuzde2: 0,
          DishatYuzde1: 0,
          DishatYuzde2: 0,
          Doviz: {
            DovizKod: null
          },
          Komisyon: null,
          Carimi: '0',
          HavayoluKontrolu: 'E',
          ServisUcreti: '0',
          YffSifir: '0',
          HavaYoluPosKodu: null,
          ServisHesapTip: 0,
          Cari: {
            Kod: null
          },
          MuhasebeKodlari: {
            BsphatMuhKodu:null,
            IchatMuhKodu: null,
            IchatKebir: null,
            IchatGrup: null,
            IchatMuavin: null,
            DishatMuhKodu: null,
            DishatKebir: null,
            DishatGrup: null,
            DishatMuavin: null,
            Reserve1: null,
            Reserve2: null,
            Reserve3: null,
            Reserve4: null,
            Reserve5: null,
            Reserve6: null,
            Reserve7: null,
            Reserve8: null,
            Reserve9: null,
            Reserve10: null,
            Reserve11: null,
            Reserve12: null,
            Reserve13: null,
            Reserve14: null,
            Reserve15: null,
            Reserve16: null,
            Reserve17: null,
            Reserve18: null,
            Reserve19: null,
            Reserve20: null,
            Reserve21: null,
            Reserve22: null,
            Reserve23: null,
            Reserve24: null,
            Reserve25: null,
            Reserve26: null,
            Reserve27: null,
            Reserve28: null,
            Reserve29: null,
            Reserve30: null,
            HavayoluPosMuhasebeKodu: null
          }
        },
        statecari: [],
        searchcari: null,
        doviztipi: [],
        denemedeger: 0,
        silinecekkayit: null,
        classdialog: false,
        classdialog_baslik: null,
        classadi: null,
        parkurdialog: false,
        parkurdialog_baslik: null,
        havayoludialog: false,
        havayoludialog_baslik: null,
        pargncbtn: false,
        parkaybtn: false,
        loading: false,
        color: 'info',
        yedeksirket: [],
        itemsparkur: [],
        bankapositems: [],
        classitems: [],
        items: [],
        search3: '',
        search1: '',
        search2: '',
        search: null,
        select: [],
        selected: '',
        m: false,
        k: false,
        dialog: false,
        dialog1: false,
        dialogmessage1: '',
        Parkur: {
          ParkurKod: '',
          Aciklama: '',
        },
        state: [],
        yenisirket: {
          id: '',
          text: '',
          unvan: ''
        },
        hyoluok: false,
        parok: false,
        clsok: false,
        dialogkisamesaj: false,
        kisamesaj: null,
        dialog_baslik: '',
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text: '',
        text1: '',
        bankakod: '',
        bankaadi: '',
        progress: false,
        dictionary: {
          custom: {
            classadi1: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            parkurkod: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            hyolukod: {
              required: () => this.$t('This-space-cannot-left-blank'),
            }
          }
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    watch: {
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.PB=credentials.ParaBirimi;
        var params = {
          CompanyCode: credentials.SirketKodu,
        }
        this.progress = true

        this.$http.post(auth.API_URL + 'api/TicketDefinitons/ParkurList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.itemsparkur = response.body
          this.progress = false
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.progress = false

            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.progress = false
            this.snackbar = true
          }
        })




        this.$http.post(auth.API_URL + 'api/currency/List', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.doviztipi = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Döviz'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-Döviz'
            this.snackbar = true
          }
        })



        this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.items = response.body
          this.progress = false
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.progress = false

            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.progress = false

            this.snackbar = true
          }
        })
        this.$http.post(auth.API_URL + 'api/TicketDefinitons/ClassList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.classitems = response.body
          this.progress = false
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.progress = false

            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.progress = false

            this.snackbar = true
          }
        })


        this.$http.post(auth.API_URL + 'api/BankPos/List', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.bankapositems = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-bankpos'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-bankpos'
            this.snackbar = true
          }
        })


      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          } 

        });

      }

    },
    methods: {
      hytemizle() {
        this.havayolu.HavaYoluTitle = null
        this.havayolu.HavaYoluKodu = null
        this.havayolu.FormNo = null
        this.havayolu.HavaYoluAdi = null
        this.havayolu.GSA = '0'
        this.havayolu.IchatYuzde1 = 0
        this.havayolu.IchatYuzde2 = 0
        this.havayolu.DishatYuzde1 = 0
        this.havayolu.DishatYuzde2 = 0
        this.havayolu.Doviz.DovizKod = null
        this.havayolu.Komisyon = null
        this.havayolu.Carimi = '0'
        this.havayolu.HavayoluKontrolu = 'E'
        this.havayolu.ServisUcreti = '0'
        this.havayolu.YffSifir = '0'
        this.havayolu.HavaYoluPosKodu = null
        this.havayolu.ServisHesapTip = 0
        this.havayolu.Cari.Kod = null
        this.havayolu.MuhasebeKodlari.IchatMuhKodu = null
        this.havayolu.MuhasebeKodlari.IchatKebir = null
        this.havayolu.MuhasebeKodlari.IchatGrup = null
        this.havayolu.MuhasebeKodlari.IchatMuavin = null
        this.havayolu.MuhasebeKodlari.DishatMuhKodu = null
        this.havayolu.MuhasebeKodlari.DishatKebir = null
        this.havayolu.MuhasebeKodlari.DishatGrup = null
        this.havayolu.MuhasebeKodlari.DishatMuavin = null
        this.havayolu.MuhasebeKodlari.Reserve1 = null
        this.havayolu.MuhasebeKodlari.Reserve2 = null
        this.havayolu.MuhasebeKodlari.Reserve3 = null
        this.havayolu.MuhasebeKodlari.Reserve4 = null
        this.havayolu.MuhasebeKodlari.Reserve5 = null
        this.havayolu.MuhasebeKodlari.Reserve6 = null
        this.havayolu.MuhasebeKodlari.Reserve7 = null
        this.havayolu.MuhasebeKodlari.Reserve8 = null
        this.havayolu.MuhasebeKodlari.Reserve9 = null
        this.havayolu.MuhasebeKodlari.Reserve10 = null
        this.havayolu.MuhasebeKodlari.Reserve11 = null
        this.havayolu.MuhasebeKodlari.Reserve12 = null
        this.havayolu.MuhasebeKodlari.Reserve13 = null
        this.havayolu.MuhasebeKodlari.Reserve14 = null
        this.havayolu.MuhasebeKodlari.Reserve15 = null
        this.havayolu.MuhasebeKodlari.Reserve16 = null
        this.havayolu.MuhasebeKodlari.Reserve17 = null
        this.havayolu.MuhasebeKodlari.Reserve18 = null
        this.havayolu.MuhasebeKodlari.Reserve19 = null
        this.havayolu.MuhasebeKodlari.Reserve20 = null
        this.havayolu.MuhasebeKodlari.Reserve21 = null
        this.havayolu.MuhasebeKodlari.Reserve22 = null
        this.havayolu.MuhasebeKodlari.Reserve23 = null
        this.havayolu.MuhasebeKodlari.Reserve24 = null
        this.havayolu.MuhasebeKodlari.Reserve25 = null
        this.havayolu.MuhasebeKodlari.Reserve26 = null
        this.havayolu.MuhasebeKodlari.Reserve27 = null
        this.havayolu.MuhasebeKodlari.Reserve28 = null
        this.havayolu.MuhasebeKodlari.Reserve29 = null
        this.havayolu.MuhasebeKodlari.Reserve30 = null
        this.havayolu.MuhasebeKodlari.HavayoluPosMuhasebeKodu = null

      },
      parkursilsor(mesaj) {
        this.clsok = false
        this.parok = true
        this.hyoluok = false
        this.silinecekkayit = mesaj
        this.kisamesaj = this.$t('Are-you-sure-you-want-to-delete-this-record')
        this.dialogkisamesaj = true
      },
      parkurgetir(kayit) {
        this.parkaybtn = false
        this.pargncbtn = true
        this.parkurdialog = true
        this.parkurdialog_baslik = this.$t('Edit-Track')
        this.Parkur = kayit
      },
      havayolugetir(kayit) {
        this.islemhy = 'guncelle'
        this.parkaybtn = false
        this.pargncbtn = true
        this.havayoludialog = true
        this.havayoludialog_baslik = this.$t('Edit-Airline')

        var seciliitems = [{
          unvan1: kayit.Cari.Kod + '-' + kayit.Cari.Unvan,
          id: kayit.Cari.Kod,
          autoText: kayit.Cari.Kod + '-' + kayit.Cari.unvan
        }]
        this.statecari = seciliitems
        this.havayolu = kayit
      },
      havayolusilsor(mesaj) {
       
        this.silinecekFormNo=mesaj.FormNo;
        this.clsok = false
        this.parok = false
        this.hyoluok = true
        this.havayolu = mesaj
        this.kisamesaj = this.$t('Are-you-sure-you-want-to-delete-this-record')
        this.dialogkisamesaj = true
      },
      classsilsor(mesaj) {
        this.clsok = true
        this.parok = false
        this.hyoluok = false
        this.silinecekkayit = mesaj
        this.kisamesaj = this.$t('Are-you-sure-you-want-to-delete-this-record')
        this.dialogkisamesaj = true
      },
      classekle() {
        this.classdialog = true
        this.classdialog_baslik = this.$t('Add-Class')
      },
      parkurekle() {
        this.Parkur.ParkurKod = null
        this.pargncbtn = false
        this.parkaybtn = true
        this.Parkur.Aciklama = null
        this.parkurdialog = true
        this.parkurdialog_baslik = this.$t('Add-Track')
      },
      havayoluekle() {
        this.islemhy = null
        this.hytemizle()
        this.pargncbtn = false
        this.parkaybtn = true
        this.havayoludialog = true
        this.havayoludialog_baslik = this.$t('Add-Airline')
      },

      deletesirket: deletesirket,
      sirketekle: sirketekle,
      ClassKaydet: ClassKaydet,
      ClassSil: ClassSil,
      ParkurSil: ParkurSil,
      HavaYoluSil: HavaYoluSil,
      ParkurKaydet: ParkurKaydet,
      guncelle: guncelle,
      HavaYoluKaydet: HavaYoluKaydet,
      parkuraktar
    },
    computed:{
          headers1() {
            return[{
            text: this.$t('Code'),
            value: 'HavaYoluKodu'
          },
          {
            text: this.$t('Form-No'),
            value: 'FormNo'
          },
          {
            text: this.$t('Description'),
            value: 'HavaYoluAdi'
          }
        ]
        },
        headers2(){
          return [{
            text: this.$t('Track-Code'),
            value: 'ParkurKod'
          },
          {
            text: this.$t('Description'),
            value: 'Aciklama'
          }
        ]
        },
        headers3(){
          return [{
          text: this.$t('Class-Name'),
          value: 'ClassAdi'
        }]
        },
    },
    beforeMount: beforeMount,

    components: {
      'yuzdeinput': yuzdeinput,
      yetkidialog,
      loadingcomp,
      cariaracomp
    },

  }


  function HavaYoluKaydet() {
    if (this.$refs.formtarih.validate()) {

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      var params = this.havayolu
      this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineAdd', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
         this.text1 = this.$t(response.body.ResponseMessage)
        this.snackbar = true

        if (response.body.Status == true) {
          this.havayoludialog = false
          var params1 = {
            CompanyCode: credentials.SirketKodu
          }
          this.classdialog = false
          this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
            this.progress = false
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.progress = false

              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable'
              this.progress = false

              this.snackbar = true
            }
          })
        }

      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable.'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable.'
          this.snackbar = true
        }
      })

    }

  }

  function ParkurKaydet() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = this.Parkur
    this.$http.post(auth.API_URL + 'api/TicketDefinitons/ParkurAdd', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
       this.text1 = this.$t(response.body.ResponseMessage)
      this.snackbar = true

      if (response.body.Status == true) {
        this.parkurdialog = false
        var params1 = {
          CompanyCode: credentials.SirketKodu
        }
        this.classdialog = false
        this.$http.post(auth.API_URL + 'api/TicketDefinitons/ParkurList', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.itemsparkur = response.body
          this.progress = false
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.progress = false

            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.progress = false

            this.snackbar = true
          }
        })

      }



    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable.'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable.'
        this.snackbar = true
      }
    })

  }

  function parkuraktar() {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));



    this.loginstatus=true

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/ParkurStream', null, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
       this.text1 = this.$t(response.body.ResponseMessage)
      this.snackbar = true

      if (response.body.Status == true) {


        var params1 = {
          CompanyCode: credentials.SirketKodu
        }
        this.classdialog = false
        this.$http.post(auth.API_URL + 'api/TicketDefinitons/ParkurList', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
           this.loginstatus=false

          this.itemsparkur = response.body
          this.progress = false
        }, (response) => {
             this.loginstatus=false

          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.progress = false

            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.progress = false

            this.snackbar = true
          }
        })

      } else {

      this.loginstatus=false

      }



    }, (response) => {
      this.loginstatus=false

      if (response.status === 0) {
        this.text1 = 'Service Unavailable.'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable.'
        this.snackbar = true
      }
    })

  }



  function ClassKaydet() {

    this.$validator.validateAll().then((result) => {
      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params = {
          CompanyCode: credentials.SirketKodu,
          ClassAdi: this.classadi,
        }
        this.$http.post(auth.API_URL + 'api/TicketDefinitons/ClassAdd', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
           this.text1 = this.$t(response.body.ResponseMessage)
          this.snackbar = true

          if (response.body.Status == true) {

            this.classdialog = false
            this.$http.post(auth.API_URL + 'api/TicketDefinitons/ClassList', params, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.classitems = response.body
              this.progress = false
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.progress = false

                this.snackbar = true
              } else {
                this.text1 = 'Service Unavailable'
                this.progress = false

                this.snackbar = true
              }
            })

          }



        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable.'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable.'
            this.snackbar = true
          }
        })
      }
    })
  }

  function ClassSil() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu,
      Code: this.silinecekkayit,
    }
    this.$http.post(auth.API_URL + 'api/TicketDefinitons/ClassDelete', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
       this.text1 = this.$t(response.body.ResponseMessage)
      this.snackbar = true
      this.dialogkisamesaj = false


      if (response.body.Status == true) {

        this.$http.post(auth.API_URL + 'api/TicketDefinitons/ClassList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.classitems = response.body
          this.progress = false
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.progress = false

            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.progress = false

            this.snackbar = true
          }
        })

      }
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable.'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable.'
        this.snackbar = true
      }
    })

  }


  function ParkurSil() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu,
      Code: this.silinecekkayit,
    }
    this.$http.post(auth.API_URL + 'api/TicketDefinitons/ParkurDelete', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
       this.text1 = this.$t(response.body.ResponseMessage)
      this.snackbar = true
      this.dialogkisamesaj = false


      if (response.body.Status == true) {

        var params1 = {
          CompanyCode: credentials.SirketKodu

        }

        this.$http.post(auth.API_URL + 'api/TicketDefinitons/ParkurList', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.itemsparkur = response.body
          this.progress = false
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.progress = false

            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.progress = false

            this.snackbar = true
          }
        })

      }
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable.'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable.'
        this.snackbar = true
      }
    })

  }



  function HavaYoluSil() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    
    var params = {
      Code: this.havayolu.HavaYoluKodu,
      FormNo: this.silinecekFormNo
    }

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineDelete', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
       this.text1 = this.$t(response.body.ResponseMessage)
      this.snackbar = true
      this.dialogkisamesaj = false

      if (response.body.Status == true) {

        var params1 = {
          CompanyCode: credentials.SirketKodu

        }

        this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.items = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })

      }
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable.'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable.'
        this.snackbar = true
      }
    })

  }



  function sirketekle() {

    this.dialog = true
    this.Sirket = {}
    this.dialog_baslik = 'Şirket Ekle'
    this.m = false
    this.k = true
    this.codegorunum = true
    this.$validator.reset()

  }

  function beforeMount() {






  }

  function deletesirket() {

    if (window.confirm('Şirket\'i silmek istediğinizden eminmisiniz?')) {

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      if (credentials.SirketKodu != this.Sirket.CompanyCode) {
        var params = this.Sirket
        var silinensirket = this.Sirket.CompanyCode
        this.$http.post(auth.API_URL + '/api/Company/Delete', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true

            //sirketleri güncelleyelim.
            var yedeksirket = []
            yedeksirket = credentials.Sirketler
            credentials.Sirketler = []

            for (let index = 0; index < yedeksirket.length; index++) {
              if (yedeksirket[index].id != silinensirket) {
                const element = yedeksirket[index];
                credentials.Sirketler.push(element)
              }
              window.localStorage.setItem('credentials', JSON.stringify(credentials));
            }

            location.reload();
            var params1 = {
              CompanyCode: credentials.SirketKodu,
            }

            this.$http.post(auth.API_URL + 'api/Company/List', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }


            }).then((response) => {
              this.items = response.body
              this.dialog = false

            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable-List'
                this.snackbar = true
              } else {
                this.text1 = 'Service Unavailable-List'
                this.snackbar = true
              }
            })

          } else {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true
          } else {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true
          }
        })

      } else {
        this.dialogmessage1 =this.$t('The-company-you-want-to-delete-is-the-currently-active-company.')
          
        this.dialog1 = true

      }

    }


  }

  function guncelle() {
    this.$validator.validateAll().then((result) => {
      if (result) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        if (credentials.SirketKodu != this.Sirket.CompanyCode) {
          var params = this.Sirket
          this.codegorunum = false
          this.$http.post(auth.API_URL + 'api/Company/Update', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            if (response.body.Status) {
               this.text1 = this.$t(response.body.ResponseMessage)
              this.snackbar = true
              this.yenisirket.id = this.Sirket.CompanyCode
              this.yenisirket.text = this.Sirket.CompanyName
              this.yenisirket.unvan = this.Sirket.CompanyTitle

              var yedeksirket = credentials.Sirketler;
              credentials.Sirketler = [];

              for (let index = 0; index < yedeksirket.length; index++) {
                const element = yedeksirket[index];
                if (this.yenisirket.id != yedeksirket[index].id) {
                  credentials.Sirketler.push(element)
                } else {
                  credentials.Sirketler.push(this.yenisirket);
                }
              }
              window.localStorage.setItem('credentials', JSON.stringify(credentials))
              location.reload();
            } else {
               this.text1 = this.$t(response.body.ResponseMessage)
              this.snackbar = true
            }
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.text1 = response.statusText
              this.snackbar = true
            }
          })

        } else {
          this.dialogmessage1 =this.$t('The-company-you-want-to-update-is-the-currently-active-company.')
           
          this.dialog1 = true
        }

      }
    })
  }
</script>

<style>
  @import '../../../assets/css/custom.css';
</style>